import { GET_FAST_QUIZ_QUESTIONS } from "./types";
import global from "../global";

// Fetch List of All type of Fast Quiz Questions
const fastQuizEndpoint = "rest_get_questions.php";

// Note: If you need to override and grab specific test question types for testing...
// We used to support specific php files for each question type but they are merged now.
// You can add the parameter qtype=MIX to grab just unscrambles though!
// rest_get_questions.php?qsid=3&qtype=PIO

export const getFastQuizQuestions = (params) => (dispatch, getState, Api) => {
  // FLAG-GETURL
  let sURL = fastQuizEndpoint + params + global.config.debugQuestionType;
  console.log(sURL);
  // console.log(sURL);
  return Api.get(fastQuizEndpoint + params).then((response) => {
    dispatch({
      type: GET_FAST_QUIZ_QUESTIONS,
      payload: response.data,
    });
    return response;
  });
};
